/**
 * GA4 (gtag.js) ecommerce event helpers.
 *
 * gtag.js is loaded in index.html via REACT_APP_GA4_ID.
 * These functions fire standard GA4 ecommerce events.
 */

function gtag() {
  if (window.gtag) {
    window.gtag.apply(null, arguments);
  }
}

/**
 * Fire GA4 view_item event.
 */
export function ga4ViewItem(product) {
  gtag("event", "view_item", {
    currency: "USD",
    value: product.price,
    items: [{
      item_id: product.id,
      item_name: product.name,
      price: product.price,
      currency: "USD",
      quantity: 1,
    }],
  });
}

/**
 * Fire GA4 add_to_cart event.
 */
export function ga4AddToCart(product, quantity = 1) {
  gtag("event", "add_to_cart", {
    currency: "USD",
    value: product.price * quantity,
    items: [{
      item_id: product.id,
      item_name: product.name,
      price: product.price,
      currency: "USD",
      quantity,
    }],
  });
}

/**
 * Fire GA4 begin_checkout event.
 */
export function ga4BeginCheckout(items, totalValue) {
  gtag("event", "begin_checkout", {
    currency: "USD",
    value: totalValue,
    items: items.map((i) => ({
      item_id: i.product_id,
      item_name: i.name,
      price: i.price,
      currency: "USD",
      quantity: i.quantity,
    })),
  });
}
